import { render, staticRenderFns } from "./TBottomSheet.vue?vue&type=template&id=6097ae74&"
import script from "./TBottomSheet.vue?vue&type=script&lang=js&"
export * from "./TBottomSheet.vue?vue&type=script&lang=js&"
import style0 from "./TBottomSheet.vue?vue&type=style&index=0&id=6097ae74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports